import React from "react";
import { motion } from "framer-motion";
import TeamImage from "../assets/getintouch.png"; // optional – remove if you don’t have one


export default function About() {
  return (
    <div className="container" style={{ paddingTop: 40, paddingBottom: 60 }}>
      <motion.h2
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="section-title"
      >
        About Smart Tech Solutions
      </motion.h2>

      <div className="about" style={{ marginTop: 18 }}>
        {/* LEFT SIDE - Story, mission, values */}
        <motion.div
          className="about-left"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <p style={{ color: "#cfe0ff", fontSize: "1.05rem", lineHeight: "1.6" }}>
            At <strong>Smart Tech Solutions</strong>, we specialize in CCTV installations, 
            computer repair, and modern web development — built with precision, 
            transparency, and a passion for technology.  
            <br /><br />
            We believe every home and business deserves reliable security, 
            efficient devices, and a strong online presence. Our team brings 
            together experienced technicians and developers to deliver solutions 
            that simply **work better, last longer, and look modern**.
          </p>

          <h3 style={{ marginTop: 24, color: "white" }}>Why Choose Us</h3>
          <ul style={{ color: "#d9e4ff", marginTop: 10, lineHeight: "1.7", fontWeight:700 }}>
            <li>✔ Fast, local support with same-day replies</li>
            <li>✔ Transparent pricing & honest diagnostics</li>
            <li>✔ Professional CCTV installation & tuning</li>
            <li>✔ Expert-level repairs for laptops & PCs</li>
            <li>✔ Clean, responsive, modern web solutions</li>
          </ul>

          <motion.div 
            initial={{ opacity: 0, y: 10 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ delay: 0.3 }}
            style={{ marginTop: 26 }}
          >
            <div
              style={{
                padding: "16px 20px",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "12px",
                border: "1px solid rgba(255,255,255,0.08)",
                backdropFilter: "blur(8px)",
                color: "#cfe0ff",
                fontSize: "0.95rem",
              }}
            >
              “Our mission is simple: **deliver technology that feels seamless** —  
              secure systems, reliable repairs, and websites that elevate your brand.”
            </div>
          </motion.div>
        </motion.div>

        {/* RIGHT SIDE – Contact + Image card */}
        <motion.div
          className="about-right"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          style={{ textAlign: "left" }}
        >
          <h3 style={{ marginTop: 0, color: "white" }}>Get in Touch</h3>

          <p style={{ color: "black", marginTop: 8, lineHeight: "1.6" }}>
            Phone: <strong>+961 70 429 013</strong><br />
            Email: <strong>smarttechsolutions.lb@gmail.com</strong>
          </p>

          <div
            style={{
              width: "100%",
              height: "180px",
              overflow: "hidden",
              borderRadius: "12px",
              marginTop: 18,
              boxShadow: "0 12px 40px rgba(0,0,0,0.25)",
            }}
          >
            {/* Remove if no image */}
            <img
              src={TeamImage}
              alt="Team"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
}
